/* eslint-disable no-undef */
(function (window) {
    "use strict";
    function defineSystemService() {
        let systemService = {};
        systemService.getProvinces = function () {
            return localStorageCacheHelper.getDataViaGet("/api/SystemService/GetProvinces", localStorageCacheHelper.localStorageKey.provincesKey);
            //return axios.get("/api/SystemService/GetProvinces");
        };
        systemService.getGenders = function () {
            //return localStorageCacheHelper.getDataViaGet("/api/SystemService/GetGenders", localStorageCacheHelper.localStorageKey.provincesKey);
            return axios.get("/api/SystemService/GetGenders").then(response => {
                return response;
            }).catch(error => {
                console.log("error", error);
                apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseCodes(error.response.status, error.response.data.supportCode);
            });
        };
        systemService.getSites = function(){
            return localStorageCacheHelper.getDataViaGet("/api/SystemService/GetSites", localStorageCacheHelper.localStorageKey.sitesKey);
        }
        return systemService;
    }
    //define globally if it doesn't already exist
    if (typeof (systemService) === "undefined") {
        window.systemService = defineSystemService();
    } else {
        console.log("systemService already defined.");
    }
})(window);